import type { IModulesNavigationPlatform } from 'core/model/interfaces/module-navigation.interface';
import { moduleNavigationService } from 'core/services/module-navigation/module-navigation.service';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../constants';
import { IModuleNavigationState } from '../types';

export const fetchModuleNavigation = createAppAsyncThunk<Array<IModulesNavigationPlatform>>(
  `${SLICE_NAMESPACE}/fetchModuleNavigation`,
  async () => moduleNavigationService.getModulesNavigation(),
);

export const fetchModuleNavigationReducer: TSliceExtraReducer<IModuleNavigationState> = builder =>
  builder
    .addCase(fetchModuleNavigation.pending, state => {
      state.isLoading = true;
    })
    .addCase(fetchModuleNavigation.rejected, state => {
      state.isLoading = false;
    })
    .addCase(fetchModuleNavigation.fulfilled, (state, action) => {
      state.modulesByPlatform = action.payload;
      state.isLoading = false;
    });
